import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { NotificationComponent } from "./notification.component";
import { NotificationService } from "./notification.service";

@NgModule({
  declarations: [NotificationComponent],
  imports: [CoreModule],
  providers: [NotificationService],
  entryComponents: [NotificationComponent],
})
export class NotificationsModule {}
